export default __webpack_public_path__ + "static/media/TaxAffidavit.1e58f965.png";